module.exports = __webpack_public_path__ + "img/volume_off.c39e5a4c.svg";